import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '@app/_services';
import { NgxSpinnerService } from "ngx-spinner";
import { LogService } from '../_shared/log.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserInfo } from '@app/_models/userInfo';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css']
})

export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    resetPasswordForm: FormGroup;
    loading = false;
    submitted = false;
    submittedReset = false;
    returnUrl: string;
    storage: Storage;
    currentUserJson;
    currentRoleJson;
    error = '';
    invalidError: string;
    requiredEmail: string;
    @ViewChild('closebutton') closebutton;
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    @ViewChild('showModalBoxResetPassword', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
    message: string;
    ErrorMessage: string;
    getresponse: any;
    userInfo = new UserInfo();

    messageToSendP: string = '';


    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private SpinnerService: NgxSpinnerService,
        private eventService: LogService,
        config: NgbModalConfig,
        private modalService: NgbModal
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }

    ngOnInit() {

        this.eventService.emit<string>("0")

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
        });

        this.resetPasswordForm = this.formBuilder.group({
            regEmail: ['', [Validators.required, Validators.email]]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }
    get ff() { return this.resetPasswordForm.controls; }

    onSubmit() {

        //this.SpinnerService.show();
        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.authenticationService.signin(this.f.username.value, this.f.password.value)
            //.pipe( first() )
            .subscribe((response) => {
                console.log(response);
                //alert(response.respMessage);
                if (response.respMessage == "Success") {

                    // this.userInfo.id = response.respData.id;
                    // this.userInfo.username = response.respData.username;
                    // this.userInfo.email = response.respData.email;
                    // this.userInfo.roles = response.respData.roles;
                    // this.userInfo.tokenType = response.respData.tokenType;
                    // this.userInfo.accessToken = response.respData.accessToken;

                    localStorage.setItem('currentUser', JSON.stringify(response));
                    //  localStorage.setItem('currentRole', JSON.stringify(response.role));
                    localStorage.setItem('currentRole', JSON.stringify(response.respData.roles));
                    localStorage.setItem('token', response.respData.accessToken);

                    localStorage.setItem('userName', JSON.stringify(response.respData.username));
                    localStorage.setItem('user_id', response.respData.id);
                    localStorage.setItem('firstname', response.respData.firstname);
                    localStorage.setItem('lastname', response.respData.lastname);
                    localStorage.setItem('phoneNo', response.respData.phoneNo);

                    // let headers = new HttpHeaders()
                    // .set('Authorization', 'Bearer ' + this.userInfo.tokenType)
                    // .set('Content-Type', 'application/json');

                    if (response.respData.roles == 1)//for student
                    {
                        localStorage.setItem('role', "student");
                        this.returnUrl = "student";
                        this.router.navigate([this.returnUrl]);
                    }
                    else if (response.respData.roles == 2)//for employer
                    {
                        localStorage.setItem('role', "employer");
                        this.returnUrl = "employer";
                        this.router.navigate([this.returnUrl]);
                    }
                    else if (response.respData.roles == 3)//for verifier
                    {

                        localStorage.setItem('role', "verifier");
                        this.returnUrl = "verifier";
                        this.router.navigate([this.returnUrl]);
                    }
                    else if (response.respData.roles == 4)//for super verifier
                    {
                        localStorage.setItem('role', "superVerifier");
                        this.returnUrl = "superVerifier";
                        this.router.navigate([this.returnUrl]);
                    }
                    else if (response.respData.roles == 5)//for  super Admin
                    {
                        localStorage.setItem('role', "superAdmin");
                        this.returnUrl = "superAdmin";
                        this.router.navigate([this.returnUrl]);
                    }

                    else if (response.respData.roles == 6)//for  Associate
                    {
                        localStorage.setItem('role', "associate");
                        this.returnUrl = "associate";
                        this.router.navigate([this.returnUrl]);
                    }
                    else if (response.respData.roles == 7)//for university
                    {
                        localStorage.setItem('role', "university");
                        this.returnUrl = "university";
                        this.router.navigate([this.returnUrl]);
                    }
                    else if (response.respData.roles == 8)//for superAssociate
                    {
                        localStorage.setItem('role', "superAssociate");
                        this.returnUrl = "superAssociate";
                        this.router.navigate([this.returnUrl]);
                    }
                }
                else if (response.respMessage == "Failure") {
                    this.error = response.respData;
                    this.invalidError = response.respData;;
                    this.loading = false;
                    //this.loginForm.clearValidators();
                    this.loginForm.reset();
                    this.loginForm.clearValidators;
                    //  this.returnUrl = "login";
                    //  this.router.navigate([this.returnUrl]);
                }
                else {
                    this.error = response.respMessage;//'Email Id or Password is incorrect';
                    //this.loading = false;
                    //  this.returnUrl = "login";
                    //  this.router.navigate([this.returnUrl]);
                }
            },
                (err: any) => {
                    this.invalidError = "Email Id or Password is incorrect.";
                    //var message=err;
                    this.loading = false;
                    //alert("Error Message"+ err);
                }
            );
    }

    refresh(): void {
        location.reload();
    }

    resetPassword(formDirective) {
        // this.modalService.open(this.showModalBoxTemplate);
        this.submittedReset = true;
        if (this.resetPasswordForm.invalid) {
            return;
        }
        this.ErrorMessage = "";
        let inputValue = (document.getElementById('regEmail') as HTMLInputElement).value;
        this.SpinnerService.show();
        this.authenticationService.resetPassword(inputValue)
            .pipe(first())
            .subscribe(
                response => {
                    if (response) {
                        this.getresponse = response;
                        if (this.getresponse.respMessage == "Success") {
                            this.SpinnerService.hide();
                            //location.reload();
                            this.message = "Email is sent to you to reset the password.";
                            this.modalService.open(this.showModalBoxTemplate);
                            // alert("Email is sent to you to reset the password.");
                        }
                        else {
                            this.SpinnerService.hide();
                            this.ErrorMessage = this.getresponse.respData;
                        }
                    }
                    else {
                        this.SpinnerService.hide();
                        this.ErrorMessage = 'Email Id or Password is incorrect';
                        this.loading = false;
                    }
                },
                error => {
                    this.SpinnerService.hide();
                    this.message = "Invalid!!!";
                    this.modalService.open(this.showModalBoxTemplate);
                    // this.requiredEmail = "Invalid!!!";
                    this.error = error;
                    this.loading = false;
                }
            );
    }

    registerStudentPage() {
        console.log("register student")
        this.returnUrl = "studentRegister";
        this.router.navigate([this.returnUrl]);
    }

    registerEmployerPage() {
        console.log("register employer")
        this.returnUrl = "employerRegister";
        this.router.navigate([this.returnUrl]);
    }
}
